import { render, staticRenderFns } from "./AppPaginate.vue?vue&type=template&id=01bb7740&scoped=true"
import script from "./AppPaginate.vue?vue&type=script&lang=js"
export * from "./AppPaginate.vue?vue&type=script&lang=js"
import style0 from "./AppPaginate.vue?vue&type=style&index=0&id=01bb7740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bb7740",
  null
  
)

export default component.exports